export enum GameSceneIdsStrings {
    BOOT_LOAD_SCENE_ID = 'BootLoadScene',
    LOAD_SCENE_ID = 'LoadScene',
    START_SCENE_ID = 'StartScene',
    INFO_SCENE_ID = 'InfoScene',
    LOGIN_SCENE_ID = 'LoginScene',
    TOP_BEST_PLAYER_SCENE_ID = 'TopBestPlayerScene',
    HELP_SCENE_ID = 'HelpScene',
    HELPER_SCENE_ID = 'HelperScene',
    MAIN_SCENE_ID = 'MainScene',
    MAP_SCENE_ID = 'MapScene',
    INTRODUCTION_SCENE_ID = 'IntroductionScene',
    END_SCENE_ID = 'EndScene',
    WARNING_MESSAGE_SCENE_ID = 'WarningMessageScene',
}
